// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ebdc71c6","239":"7c3e3c37","453":"670e15c7","732":"f0b68464"}[chunkId] + ".chunk.js";
};